/**
 * @typedef {import('./core/MapLibreMap.js').MLD} MLD
 */

window.OSM = window.OSM ?? {};
/**
 * @type {IMapsProps}
 */
OSM.MapConfigs = OSM.MapConfigs ?? {}

/**
 * See MapCoreConfig.js for a working example
 * @type {IMapProps}
 */
OSM.MapConfigs.default = {
    canPreferPortrait: true,
    primaryMarker: {
        iconProps: {
            color: "#732a81",
        }
    },

    cluster: {

        marker: {
            iconProps: {
                color: "#732a81",
            },
        },
    }
}
